// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "dialog__header-KKltq";
export { _1 as "__esModule", _2 as "dialog__header" }
export default { "__esModule": _1, "dialog__header": _2 }
